// extracted by mini-css-extract-plugin
export default {"events":"EventsTab_events__6mmdo","eventsBlock":"EventsTab_eventsBlock__W8axy","actions":"EventsTab_actions__tFc9o"};